import React from 'react';

interface Props {}

const ArrowRightMedium3 = (props: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
            <path
                d="M13.7686 5.6037C14.1684 6.02678 14.3735 6.59087 14.3735 7.14412C14.3735 7.69738 14.1684 8.26146 13.7686 8.68454L9.36975 13.3384L7.92397 11.8088L11.3077 8.22894L0.0288087 8.22894L0.0288087 6.0593L11.2974 6.0593L7.92397 2.47943L9.36975 0.949797L13.7686 5.6037Z"
                fill="black"
            />
        </svg>
    );
};
export default ArrowRightMedium3;
